export type PasswordStrength = 0 | 1 | 2 | 3 | 4;

export const calculatePasswordStrength = (value: string): PasswordStrength => {
  if (!value) return 0;
  let score: number = 0;
  if (value.length >= 8) score++;
  if (/[A-Z]/.test(value)) score++;
  if (/\d/.test(value)) score++;
  if (/[^A-Za-z0-9]/.test(value)) score++;
  return Math.min(score, 4) as PasswordStrength;
};
